const common = {
  siteName: '吃瓜视频',
  siteDescription: '吃瓜视频网站每日更新，专注网红黑料实时追踪与明星八卦爆料，提供国产吃瓜视频在线观看完整版延禧攻略等热门内容',
  navHome: '首页',
  navWanghong: '网红黑料',
  navMingxing: '明星八卦',
  navRemen: '热门吃瓜',
  navAbout: '关于我们',
  search: '搜索',
  subscribe: '订阅',
  readMore: '查看更多',
  viewAll: '查看全部',
  loading: '加载中...',
  noMore: '没有更多了',
  copyright: '吃瓜视频 版权所有',
};

export default common;